import { forwardRef } from '@wordpress/element';
import { PolymorphicElement } from '../utils/polymorphic-element';
import { jsx as _jsx } from "react/jsx-runtime";
function UnforwardedView({
  css,
  ...restProps
}, ref) {
  void css;
  return /*#__PURE__*/_jsx(PolymorphicElement, {
    ref: ref,
    ...restProps
  });
}

/**
 * `View` is a core component that renders everything in the library.
 * It is the principle component in the entire library.
 *
 * ```jsx
 * import { View } from `@wordpress/components`;
 *
 * function Example() {
 * 	return (
 * 		<View>
 * 			 Code is Poetry
 * 		</View>
 * 	);
 * }
 * ```
 */
export const View = Object.assign(forwardRef(UnforwardedView), {
  selector: '.components-view'
});
export default View;